<div class="coach-shell">
  <header class="coach-header">
    <div>
      <p class="coach-eyebrow">AI Tennis Coach</p>
      <h1>Advanced video angles & instant coaching feedback</h1>
      <p class="coach-subtitle">
        Drag clips and feedback between columns to curate your session.
        Gemini insights and our custom models power angle detection, footwork
        tracking, and personalized drills.
      </p>
    </div>
    <div class="coach-actions">
      <input
        #uploadInput
        type="file"
        accept="image/*,video/*"
        hidden
        (change)="handleUpload($event)" />
      <button mat-stroked-button type="button" (click)="openUploadPicker()">Upload session</button>
      <button mat-raised-button color="primary" type="button">
        Generate feedback
      </button>
    </div>
  </header>
  <p class="coach-subtitle" *ngIf="uploadState">
    Upload status: {{ uploadState.status }} · {{ uploadState.percentage }}%
    <span *ngIf="uploadState.error">— {{ uploadState.error }}</span>
  </p>
  <p class="coach-subtitle" *ngIf="analysisState">
    Analysis: {{ analysisState.state }} · {{ analysisState.progress }}%
  </p>

  <section class="coach-highlight">
    <div class="highlight-card">
      <h3>Multi-angle analysis</h3>
      <p>Baseline, side, and net cams merged into a single coaching timeline.</p>
      <span class="chip">3 camera blend</span>
    </div>
    <div class="highlight-card">
      <h3>Gemini + custom models</h3>
      <p>Serve diagnostics, swing tempo, and footwork cadence calibrated to you.</p>
      <span class="chip">Hybrid AI</span>
    </div>
    <div class="highlight-card">
      <h3>Drill recommendations</h3>
      <p>Auto-generated drills map directly to the detected swing pattern.</p>
      <span class="chip">Actionable drills</span>
    </div>
  </section>

  <section class="coach-columns">
    <div class="column">
      <div class="column-header">
        <h2>Video library</h2>
        <p>Drag clips to reorder or drop into feedback to build a coaching reel.</p>
      </div>

      <div
        cdkDropList
        id="videoList"
        class="asset-list"
        [cdkDropListData]="videoClips"
        [cdkDropListConnectedTo]="['feedbackList']"
        (cdkDropListDropped)="dropAsset($event)">
        <article
          class="asset-card"
          *ngFor="let clip of videoClips; trackBy: trackById"
          cdkDrag>
          <header>
            <h3>{{ clip.title }}</h3>
            <span class="badge" [class]="clip.intensity">{{ clip.intensity }}</span>
          </header>
          <p>{{ clip.description }}</p>
          <div class="meta-row">
            <span class="meta-title">Angles</span>
            <div class="meta-chips">
              <span class="chip" *ngFor="let angle of clip.angles">{{ angle }}</span>
            </div>
          </div>
          <div class="meta-row">
            <span class="meta-title">Tags</span>
            <div class="meta-chips">
              <span class="chip" *ngFor="let tag of clip.tags">{{ tag }}</span>
            </div>
          </div>
          <footer>
            <span class="source">{{ clip.source }}</span>
            <button mat-button type="button">Open clip</button>
          </footer>
        </article>
      </div>
    </div>

    <div class="column">
      <div class="column-header">
        <h2>Generated feedback</h2>
        <p>Drop insights onto videos to create a tailored coaching playlist.</p>
      </div>

      <div
        cdkDropList
        id="feedbackList"
        class="asset-list"
        [cdkDropListData]="feedbackCards"
        [cdkDropListConnectedTo]="['videoList']"
        (cdkDropListDropped)="dropAsset($event)">
        <article
          class="asset-card"
          *ngFor="let feedback of feedbackCards; trackBy: trackById"
          cdkDrag>
          <header>
            <h3>{{ feedback.title }}</h3>
            <span class="badge" [class]="feedback.intensity">{{ feedback.intensity }}</span>
          </header>
          <p>{{ feedback.description }}</p>
          <div class="meta-row">
            <span class="meta-title">Angle focus</span>
            <div class="meta-chips">
              <span class="chip" *ngFor="let angle of feedback.angles">{{ angle }}</span>
            </div>
          </div>
          <div class="meta-row">
            <span class="meta-title">Tags</span>
            <div class="meta-chips">
              <span class="chip" *ngFor="let tag of feedback.tags">{{ tag }}</span>
            </div>
          </div>
          <footer>
            <span class="source">{{ feedback.source }}</span>
            <button mat-button type="button">View drill plan</button>
          </footer>
        </article>
      </div>
    </div>
  </section>
</div>
